/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input'
import 'owl.carousel'
import Swiper, { Navigation, Pagination } from 'swiper'
import { setHrefs } from './functions/data-hrefs'
import { initEqualizeContent } from './functions/equalizer'
import { initTelephoneInput } from './functions/intl-tel-input'
import { initDatepickerInput } from './functions/datepicker'
import { enableNegativeMargins } from './functions/negative-margins'
import { mapStyles } from './functions/map-styles'
// import { enableCallrailTracking } from './functions/callrail'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */



/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/greater_state_bank_v1"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"

Foundation.addToJquery(jQuery)
Swiper.use([Navigation, Pagination])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */



jQuery(document).ready(function () {
	jQuery(document).foundation();
	triggerThemeFunctions();

	

	// Initialize Single Community Gallery
	if (jQuery('#single-community-carousel').length !== 0) {
		singleCommunityGalleryFunction();
	}

	var swiper = new Swiper(".footerlocationSwiper", {
		scrollbar: { el: ". swiper-scrollbar", hide: true, },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
		pagination: {
            el: '.footerlocationSwiper .swiper-pagination',
            clickable: true,
        },
		breakpoints: {
            640: {
                slidesPerView: 1,
                slidesPerColumn: 1,
            },
            1024: {
                slidesPerView: 3,
                slidesPerColumn: 1,
            },
            1200: {
                slidesPerView: 3,
                slidesPerColumn: 1,
            },
            1440: {
                slidesPerView: 4,
                slidesPerColumn: 1,
            },
        }
    });

	var swiper = new Swiper('#donna-swiper .swiper-container', {
		pagination: {
			el: '#donna-swiper .swiper-pagination',
			clickable: true,
		},
		slidesPerView: 1,
		grabCursor: true,
		// navigation: {
		// 	nextEl: "#course-swiper .swiper-container .swiper-button-next",
		// 	prevEl: "#course-swiper .swiper-container .swiper-button-prev",
		//   },
		breakpoints: {
			640: {
				slidesPerView: 1,
				slidesPerColumn: 1,
			},
			1024: {
				slidesPerView: 2,
				slidesPerColumn: 1,
			},
			1200: {
				slidesPerView: 2,
				slidesPerColumn: 1,
			},
			1440: {
				slidesPerView: 2,
				slidesPerColumn: 1,
			},
		}
	});

	const locationSwiper = new Swiper('#location_swiper', {
		direction: 'horizontal',
		slidesPerView: 5,
		spaceBetween: 30,
		observer: true,
		observeParents: true,
		parallax: true,
		pagination:
		{
			el: '#location_swiper .location-pagination',
			clickable: true,
		},

		breakpoints: {
			0:
			{
				slidesPerView: 1,
				spaceBetween: 20,
			},

			640:
			{
				slidesPerView: 2,
				spaceBetween: 20,
			},

			1024:
			{
				slidesPerView: 3,
				spaceBetween: 30,
			},

			1440:
			{
				slidesPerView: 4,
				spaceBetween: 30,
			}

		}

	});

	const ServiceSwiper = new Swiper('#service_carousel', {
		direction: 'horizontal',
		slidesPerView: 5,
		spaceBetween: 30,
		observer: true,
		observeParents: true,
		parallax: true,
		pagination:
		{
			el: '#service_carousel .service-gallery-pagination',
			clickable: true,
		},

		breakpoints: {
			0:
			{
				slidesPerView: 2,
				spaceBetween: 20,
			},

			640:
			{
				slidesPerView: 3,
				spaceBetween: 20,
			},

			1024:
			{
				slidesPerView: 5,
				spaceBetween: 30,
			}

		},
	});

	const MobileSwiper = new Swiper('#mobile-slides_carousel .home-mobile-banking-swiper', {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		navigation:
		{
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		// on: {
		// 	'init': function() {
		// 		new Foundation.Equalizer(jQuery("#mobile-slides_carousel img")).applyHeight();
		// 	}
		// },
	});

	// External link warning
	var root = new RegExp(location.host);
	var relativeCheck = ':/';
	jQuery('a').each(function () {
		var link = jQuery(this).attr('href');
		if (typeof (link) != "undefined") {
			if (link.indexOf(':/') === -1 || link.indexOf('gst') > -1 || link.indexOf('tdcecom.com/') !== -1 || root.test(link)) {
				jQuery(this).addClass('local');
			}
			else {
				// a link that does not contain the current host
				var url = jQuery(this).attr('href');
				if (url)
				//if(url.length > 1)
				{
					jQuery(this).addClass('external');
				}
			}
		}
	});
	jQuery('a.external').on('click', function (e) {
		e.preventDefault();
		var answer = confirm("You are about to leave https://greaterstate.bank/ and enter a website that Greater State Bank does not control. Greater State Bank has provided this link for your convenience, but is not responsible for the content, links, privacy policy, or security policy of this website.");
		if (answer) {
			window.location = jQuery(this).attr('href');
		}
	});

	document.querySelectorAll('.pdf-open a').forEach(function(link) { 
		link.setAttribute("target", "_blank"); 
	}); 

});





/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions() {
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function () {
		if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function () {
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */

function singleCommunityGalleryFunction() {
	// SINGLE COMMUNITY GALLERY
	// reference for main items
	var singleCommunityCarousel = jQuery('#single-community-carousel');
	// reference for thumbnail items
	var singleCommunityThumbnailCarousel = jQuery('#single-community-carousel-thumbs');
	//transition time in ms
	var duration = 300;

	singleCommunityCarousel.owlCarousel({
		loop: false,
		margin: 0,
		nav: false,
		dots: false,
		autoplay: true,
		autoplayTimeout: 15000,
		autoHeight: true,
		responsive: {
			0: {
				items: 1
			},
			300: {
				items: 1
			},
			600: {
				items: 1
			},
			900: {
				items: 1
			},
			1200: {
				items: 1
			},
			1440: {
				items: 1
			}
		}
	}).on('changed.owl.carousel', function (e) {
		//On change of main item to trigger thumbnail item
		singleCommunityThumbnailCarousel.trigger('to.owl.carousel', [e.item.index, duration, true]);
		singleCommunityThumbnailCarousel.find('.current').removeClass('current');
		var index = e.item.index;
		var offset = jQuery(e.target).find('.active:first').prevAll('.cloned').length;
		singleCommunityThumbnailCarousel.find('.owl-item').eq(index - offset).addClass('current');
	});

	singleCommunityThumbnailCarousel.owlCarousel({
		loop: false,
		margin: 24,
		nav: false,
		dots: false,
		autoplay: false,
		responsive: {
			0: {
				items: 2
			},
			300: {
				items: 2
			},
			600: {
				items: 3
			},
			900: {
				items: 4
			},
			1200: {
				items: 5
			},
			1440: {
				items: 5
			}
		}
	}).on('click', '.owl-item', function () {
		// On click of thumbnail items to trigger same main item
		singleCommunityCarousel.trigger('to.owl.carousel', [jQuery(this).index(), duration, true]);
		singleCommunityThumbnailCarousel.find('.current').removeClass('current');
		jQuery(this).addClass('current');

	}).on('changed.owl.carousel', function (e) {
		// On change of thumbnail item to trigger main item
		singleCommunityCarousel.trigger('to.owl.carousel', [e.item.index, duration, true]);
	});

	singleCommunityThumbnailCarousel.find('.owl-item').first().addClass('current');

	jQuery('#singleCommunityCarouselRight').click(function () {
		singleCommunityCarousel.trigger('next.owl.carousel');
	});
	jQuery('#singleCommunityCarouselLeft').click(function () {
		singleCommunityCarousel.trigger('prev.owl.carousel');
	});
}